import type { NestedFilter } from '@@partner:graphql/types'
import type { FilterConfig } from '@components/common/filter/FilterConfig'

import React, { useCallback } from 'react'
import { Tag } from 'rsuite'
import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { getSearchableStoriesStatuses, prepareStoriesFilter } from '@@partner:helpers/stories'

export interface StoriesFiltersType {
  name?: string
  statuses: number[]
  activeFrom?: { from?: number; to?: number }
  activeUntil?: { from?: number; to?: number }
}

export interface StoriesFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

const AVAILABLE_STORIES_STATUSES = getSearchableStoriesStatuses()

const defaultFilter: StoriesFiltersType = {
  name: undefined,
  statuses: [],
  activeFrom: undefined,
  activeUntil: undefined
}

const filterConfig: FilterConfig[] = [
  createFilter.text('name', 'Название'),
  createFilter.multiselect(
    'statuses',
    AVAILABLE_STORIES_STATUSES,
    'Статус',
    {
      searchable: false,
      renderMenuItem: (label, item) => (
        <Tag key={item?.value} color={item?.color}>
          {label}
        </Tag>
      )
    }
  ),
  createFilter.dateRange('activeFrom', 'Активен с'),
  createFilter.dateRange('activeUntil', 'Активен до')
]

export default function StoriesFilter ({
  onFilterChanged
}: StoriesFilterProps) {
  const handleSearch = useCallback((state: StoriesFiltersType) => {
    onFilterChanged(prepareStoriesFilter(state))
  }, [ onFilterChanged ])

  return (
    <FilterPanel<StoriesFiltersType>
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSearch}
    />
  )
}
